
export interface LayoutHeaderMenu {
    name?: string | null;
    type: LayoutHeaderMenuType;
    rota?: string | null;
    class?: string | null;
    icone?: string| null;
    acao?: Function | null;
}

export enum LayoutHeaderMenuType
{
        Menu = 1,
        Divisoria = 2
}

